import API_URL from '../../../config/api';

export async function fetchGeoJson({ tableName, bounds, offset, limit, token }) {
  const url = `${API_URL}/api/layers/${tableName}?minX=${bounds.getWest()}&minY=${bounds.getSouth()}&maxX=${bounds.getEast()}&maxY=${bounds.getNorth()}&limit=${limit}&offset=${offset}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
